import React from 'react';

import { computed } from 'mobx';
import type { IWrappedComponent } from 'mobx-react';
import { inject, observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import type { AuthStoreType } from 'bz-stores/lib/auth-store';
import { AuthStoreMode } from 'bz-stores/lib/auth-store';

import type { IProps as IDialogProps } from 'bz-core-controls/controls/modal/dialog/internal';
import Dialog from 'bz-core-controls/controls/modal/dialog/internal';

// TODO: update any when core dialog implements a typescript interface

export interface IProps extends Omit<IDialogProps, 'classes'> {
  authStore?: AuthStoreType;
}

@inject('authStore')
@observer
class SecureCoreDialog extends React.Component<IProps> {
  readonly dialog: React.RefObject<Dialog> = React.createRef();

  render() {
    const { authStore, css, className, ...dialogProps } = this.props;

    return (
      <Dialog {...dialogProps} ref={this.dialog} className={this.className}>
        {this.props.children}
      </Dialog>
    );
  }

  @bind
  public close(): void {
    const { current: dialog } = this.dialog;
    if (!!dialog) {
      dialog.close();
    }
  }

  @computed
  private get className(): string {
    const { authStore, className } = this.props;
    const { mode } = authStore!;
    const classNames = [];

    if (!!className) {
      classNames.push(className);
    }

    if (mode !== AuthStoreMode.none) {
      classNames.push('dialog-blur');
    }

    return classNames.join(' ');
  }
}

class HackForInjectRefs extends React.Component<IProps> {
  readonly wrapperRef: React.RefObject<SecureCoreDialog> = React.createRef();

  @bind
  public close(): void {
    let dialog = this.wrapperRef.current as unknown as IWrappedComponent<IProps>;
    if (!!dialog) {
      (dialog.dialog.current as SecureCoreDialog).close();
    }
  }

  render() {
    const { css, ...dialogProps } = this.props;
    return <SecureCoreDialog {...dialogProps} ref={this.wrapperRef} />;
  }
}

export default HackForInjectRefs;
